export default "__VITE_ASSET__BXUAhy1d__"